/**
 * Car Main class
 * Clase para todas las secciones del auto
 */
window.Car = new (function () {
    const Swal = require('sweetalert2');
    const that = this;

    /* ===========================
     *  MÉTODOS PÚBLICOS
     * =========================== */

    this.init = function () {
        /* --- Menú de año (dropdown) --- */
        $('.DropHandler').on('click', function () {
            $(this).parent().toggleClass('openDrop');
            $(this).toggleClass('showYear');

            if ($('.VehicleOwnMenu-active').hasClass('openMenuMb')) {
                $('.VehicleOwnMenu-active').toggleClass('openMenuMb');
                $('.VehicleOwnMenu-links').toggleClass('openMenuMb');
            }
        });

        /* --- Menú de vehículos en mobile --- */
        $('.VehicleOwnMenu-active').on('click', function () {
            $(this).toggleClass('openMenuMb');
            $('.VehicleOwnMenu-links').toggleClass('openMenuMb');

            if ($('.DropHandler').hasClass('showYear')) {
                $('.DropHandler').parent().toggleClass('openDrop');
                $('.DropHandler').toggleClass('showYear');
            }
        });

        $('.VehicleOwnMenu-active span').text($('.VehicleOwnMenu-links .active').text());
        $('.VehicleOwnMenu-links li a').on('click', that.addRemoveActiveCarSectionsMenu);

        /* ==========
         * DISCLAIMER
         * ========== */

        // Abrir (delegado para contenido dinámico y slides clonados)
        $(document).on('click', '.description, .Description, .disclaimer-up', function (e) {
            that.showDisclaimer.call(this, e);
        });

        // Cerrar con botón
        $(document).on('click', '.close-disclaimer', function (e) {
            e.preventDefault();
            e.stopPropagation();
            that.removeDisclaimer();
        });

        // Evitar que clicks dentro de la caja burbujeen al document
        $(document).on('click', '.disclaimer-wrap', function (e) {
            e.stopPropagation();
        });

        // --- Cierre al hacer click FUERA usando FASE DE CAPTURA (opción 1) ---
        // helper para saber si el click fue dentro de elementos del disclaimer
        const clickDentroDeDisclaimer = (evt) => {
            return !!$(evt.target).closest('.disclaimer-wrap, .disclaimer-up, .description, .Description').length;
        };
        // listener en captura (3er parámetro true)
        const onDocClickCapture = (evt) => {
            if (!clickDentroDeDisclaimer(evt)) {
                that.removeDisclaimer();
            }
        };
        // quitamos posibles handlers previos en burbujeo
        $(document).off('click.disclaimerOutside');
        // registramos captura (funciona aunque otros hagan stopPropagation)
        document.addEventListener('click', onDocClickCapture, true);
        document.addEventListener('touchstart', onDocClickCapture, true);
        // --- fin opción 1 ---

        // Cerrar con scroll (solo si está abierto)
        $(window).on('scroll', function () {
            if ($('main .disclaimer-wrap').length) that.removeDisclaimer();
        });

        // Cerrar con tecla ESC
        $(document).on('keyup', function (e) {
            if (e.key === 'Escape') that.removeDisclaimer();
        });
    };

    /* --- Activa item del menú de secciones --- */
    this.addRemoveActiveCarSectionsMenu = function () {
        $(this).addClass('active');
    };

    /* --- Abrir popup de cotización (Guatemala) --- */
    this.openGuatemalaQuoteForm = function () {
        Swal.fire({
            icon: 'info',
            html: htmlFormGuatemala,
            showConfirmButton: false,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            customClass: 'guatemala-popup'
        });
    };

    /* --- Enviar cotización (Guatemala) --- */
    this.sendGuatemalaQuotationForm = function () {
        const inputFields = $('#quotation-guatemala-form input, #quotation-guatemala-form select');
        let validationPass = true;

        $.each(inputFields, function (_i, input) {
            $(input).removeClass('inputError');
            $('#quotation-guatemala-form .error').addClass('d-none');

            if ($(input).val() === '') {
                validationPass = false;
                $(input).addClass('inputError');
            }

            if ($(input).attr('type') === 'email' && !Main.isValidEmailAddress($(input).val())) {
                validationPass = false;
                $(input).addClass('inputError');
            }

            if (!validationPass) {
                $('#quotation-guatemala-form .error').removeClass('d-none');
            }
        });

        if (!validationPass) return;

        const fname  = $('form#quotation-guatemala-form input#name').val();
        const flname = $('form#quotation-guatemala-form input#last_name').val();
        const femail = $('form#quotation-guatemala-form input#email').val();
        const fphone = $('form#quotation-guatemala-form input#phone').val();
        const filine = $('form#quotation-guatemala-form select#interest-line').val();

        Swal.fire({
            title: 'Procesando',
            text: 'Por favor, espere mientras sus datos son enviados',
            showCloseButton: false,
            didOpen: () => Swal.showLoading()
        });

        $.ajax({
            type: 'POST',
            url: sendQuotationGuatemala,
            data: {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                'name': fname,
                'last_name': flname,
                'email': femail,
                'phone': fphone,
                'interest-line': filine
            },
            success: function () {
                Swal.fire('¡Gracias!', 'Los datos fueron enviados. Te contactarémos en breve.', 'success');
            }
        });
    };

    /* --- Mostrar disclaimer --- */
    this.showDisclaimer = function (e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }

        // Si clicaste el asterisco, úsalo; si no, busca dentro del contenedor
        let $span = $(e && e.target).closest('span.disclaimer-up');
        if (!$span.length) $span = $(this).find('span.disclaimer-up').first();
        if (!$span.length) return false;

        const id = $span.data('id');
        const $content = $('.disclaimer-pop-' + id).first();
        if (!$content.length) return false;

        // Evita duplicados
        $('main .disclaimer-wrap').remove();

        // Inserta caja
        $('main').append(
            '<div class="disclaimer-wrap">' +
            '<span class="close-disclaimer"></span>' +
            $content.html() +
            '</div>'
        );

        // Anima tras reflow
        requestAnimationFrame(function () {
            $('.disclaimer-wrap').css({ bottom: 0, opacity: 1 });
        });
    };

    /* --- Quitar disclaimer --- */
    this.removeDisclaimer = function () {
        $('main .disclaimer-wrap').remove();
    };
})();

/* ===========================
 *  EXTRAS FUERA DE LA CLASE
 * =========================== */

// Sticky menu on top when scrolling
let wrapper = $('#content'),
    vehicleNav = $('.VehicleOwnMenu');

let sticky = function () {
    let $scrollTop = $(window).scrollTop();
    if (vehicleNav.length > 0) {
        if ($scrollTop > 30) {
            wrapper.addClass('sticky');
        } else {
            wrapper.removeClass('sticky');
        }
    }
    Car.removeDisclaimer();
};

$(window).on('scroll', sticky);
$(window).on('resize', function () {
    Colors.removeHeight && Colors.removeHeight();
});

// Inicializa cuando el DOM esté listo
$(function(){ Car.init(); });
